import script from "./LiquidityApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidityApp.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"LiquidityApp.vue"]])

export default __exports__